export const titles = [{
    id: 1,
    title: 'Mr'
},
{
    id: 2,
    title: 'Mrs'
},
{
    id: 3,
    title: 'Miss'
}];

export const regex = {
    'email': /^(([^<>()[\]\\.,;:\s@"]+(\.[^<>()[\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/
} 
